import { Edge, Node } from "reactflow";
import { prepare_ai_future, prepare_global_warming } from "../../user-study/script";
import { TaskValue } from "../../user-study/task-by-group";

export const initialPrepareNodes = (task: TaskValue): Node[] => {
  return [
    {
      id: 'memo-1',
      type: 'memo',
      data: {
        placeholder: '',
        state: {
          title: '① Task instruction',
          memo: task === TaskValue.AIFutureWork ? prepare_ai_future : prepare_global_warming,
          isEditing: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 80, y: 0 },
    },
    {
      id: '6',
      type: 'topic',
      data: {
        placeholder: '',
        state: {
          topic: 'which is healthier? banana? or apple?',
          hasFourHandles: true,
          toolbarAvailable: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 250, y: 650 },
    },
    {
      id: 'memo-2',
      type: 'memo',
      data: {
        placeholder: '',
        state: {
          title: '② Features',
          memo: `• You can connect nodes like this by clicking on node handle and connecting 
    it to another handle (see ◄ left example).
  
  • You can add node by double clicking on canvas.
  
  • You can edit node by clicking edit button on node.

  • You can group nodes by selecting multiple nodes and selecting Form Group.
          `,
          isEditing: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 810, y: 160 },
    },
    {
      id: 'memo-3',
      type: 'memo',
      data: {
        placeholder: '',
        state: {
          title: '③ Navigation',
          memo: `You can navigate using the following:
  
  ➊ Zoom & Fit: Three buttons (left)
  ➋ Zoom: (Command/Alt) + Scroll
  ➌ Pan: Space + drag mouse
  ➍ Pan & Zoom: MiniMap
  
  
  zoom: pitch or cmd + scroll
  create selection: drag mouse
  
  ➡ Try these navigations before proceeding.
          `,
          isEditing: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 780, y: 560 },
    },
    {
      id: '2',
      type: 'topic',
      data: {
        placeholder: '',
        state: {
          topic: 'apple',
          hasFourHandles: true,
          toolbarAvailable: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 0, y: 300 },
    },
  
    {
      id: '3',
      type: 'topic',
      data: {
        placeholder: '',
        state: {
          topic: 'what makes apple a healthy fruit?',
          hasFourHandles: true,
          toolbarAvailable: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 30, y: 500 },
    },
  
    {
      id: 'topic-4',
      type: 'topic',
      data: {
        placeholder: '',
        state: {
          topic: 'banana',
          hasFourHandles: true,
          toolbarAvailable: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 400, y: 300 },
    },
  
    {
      id: 'topic-5',
      type: 'topic',
      data: {
        placeholder: '',
        state: {
          topic: 'what are health benefits of banana?',
          hasFourHandles: true,
          toolbarAvailable: false,
        }
      },
      dragHandle: '.drag-handle',
      position: { x: 500, y: 460 },
    },
  
  ];
  
} 
export const initialPrepareEdges: Edge[] = [
  {
    id: 'edge-2-3',
    source: 'topic-4',
    target: 'topic-5',
    sourceHandle: 'source-e-1',
    targetHandle: 'target-e-1',
    type: 'default',
  },
];
